export const dummyPassword = 'cWNxSzlMSTM7XV1TXVklYFVMcSY';
